import './GenerativeSolution.css';

export default function GenerativeSolution() {
  return (
    <div id='generative-solution' className='generativemainclass'>
            <div className="left">
<h2 className='heading'>Generative AI Solutions For Enterprise Agility</h2>
<p className='subheading'>Enterprise leaders are moving beyond experimentation with Generative AI to fundamentally transform how value is created, scaled, and sustained. From intelligent agents automating complex workflows to advanced content systems, GenAI is becoming central to modern business operations. </p>
<p className='subheading'>At BastionEx, we help organizations cut through complexity by identifying high-impact use cases, building responsible and secure AI solutions, and integrating them seamlessly into existing systems. Our approach balances technology and people to ensure long-term success.</p>
<p className='subheading'>Whether the objective is improving customer experiences, optimizing operations, or accelerating data-driven decisions, we design Generative AI solutions aligned with your strategy and built to scale with your vision.
</p>
            </div>
            <div className="line"></div>
            <div className="right">
<div className='count'>
<h2>60%</h2>
<span>Reduction in manual effort via GenAI-led workflow automation</span>
</div>
<div className="count countborder">
  <h2>50%</h2>
  <span>Reduction in operational costs through intelligent process automation</span>
</div>
<div className="count">
  <h2>3x</h2>
  <span>Faster insights generation using natural language analytics & agentic AI</span>
</div>
            </div>
    </div>
  )
}
